import request, { format } from '@/utils/request';
import { DATA_CENTER_PORTAL_PATH } from '../configs/path';

export async function query() {
  return request('/user', {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function queryCurrent() {
  return await format(
    request('/user', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  );
}

export async function getAccessToken(code, originalUrl = '') {
  return request(
    `${DATA_CENTER_PORTAL_PATH}/sso/callback?code=${code}&original-url=${originalUrl}`
  );
}

export async function queryUacMenu() {
  return await format(
    request('/uac/menu', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  ) || {};
}
